import type { ActionReducerMapBuilder } from '@reduxjs/toolkit'
import { saveErrorInState, dismissError as commonDismissError } from '../common/error/errorAPI'
import type { fetchMonthlyEngineStats } from './adminAPI'
import type { AdminState, MonthlyEngineStats } from './types'

export const buildExtraReducers = (
  builder: ActionReducerMapBuilder<AdminState>,
  thunks: {
    fetchMonthlyEngineStats: typeof fetchMonthlyEngineStats
  }
) =>
  builder
    .addCase(thunks.fetchMonthlyEngineStats.pending, (state) => {
      state.fetching = true
    })
    .addCase(thunks.fetchMonthlyEngineStats.fulfilled, (state, action) => {
      state.fetching = false
      state.monthlyEngineStats = action.payload as MonthlyEngineStats
      state.lastFetchedRequestId = action.meta.requestId
    })
    .addCase(thunks.fetchMonthlyEngineStats.rejected, (state, action) => {
      // A request aborted because a newer one replaced it (range change, unmount, StrictMode's double
      // effect) is not an error, and the newer request's pending already owns `fetching`.
      if (action.meta.aborted) {
        return
      }
      saveErrorInState((errorState) => {
        errorState.fetching = false
      })(state, action)
    })

export { commonDismissError as dismissErrorReducer }
